import { Helmet } from "react-helmet-async";

// Canonical + Open Graph always point at the live production domain.
export const SITE = "https://centennialdealershipsystem.com";
const DEFAULT_IMG = `${SITE}/cdos-og.png`;

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Centennial Business Systems",
  alternateName: "Centennial Dealership Operating System",
  url: SITE,
  logo: `${SITE}/cdos-logo.png`,
  description:
    "Operating procedures, management forms, compliance resources and training for dealership service, parts, sales, HR and collision operations.",
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Centennial Dealership Operating System",
  url: SITE,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE}/forms?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export function breadcrumb(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE}${it.path}`,
    })),
  };
}

/**
 * Per-page SEO: title, meta description, canonical URL, Open Graph, Twitter card
 * and optional JSON-LD structured data blocks.
 */
export function Seo({ title, description, canonicalPath, image, type = "website", noindex = false, jsonLd }) {
  const url = canonicalPath ? `${SITE}${canonicalPath}` : SITE;
  const img = image || DEFAULT_IMG;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content={type} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="Centennial Dealership Operating System" />
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
